<app-ui-main-menu>
    <mat-card>
        <mat-card-header>
            <mat-card-title>Procedimentos</mat-card-title>
        </mat-card-header>
    
        <mat-divider></mat-divider>
        <mat-card-content>
            <br />
            <br />
            <div class="row">
                <div class="col-6 d-flex flex-wrap" style="align-items: center;">
                    <div class="col-lg-6 col-md-7 col-sm-7 mb-2 mb-md-0">
                        <button 
                            mat-button
                            class="btn-primary w-100"
                            (click)="openModalCreateProcedure()"
                        >
                        Criar procedimento
                        </button>
                    </div>
                    <div class="col-12 col-sm-6">
                        <mat-form-field appearance="outline" class="filters" >
                            <mat-label>Filtros</mat-label>
                            <mat-select [(ngModel)]="filterList" (selectionChange)="filterProcedure()">
                              <mat-option 
                                *ngFor="let f of filter" 
                                [value]="f.boolean"
                                >
                                {{ f.name }}
                            </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <table>
                    <thead>
                        <tr>
                            <div class="table-header">
                                <th style="width: 2%;"></th>
                                <th>Nome do procedimento</th>
                                <th>Nome do plano</th>
                            </div>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let info of procedureList" class="col-12 d-flex flex-column">
                            <div class="list-container" title="Abrir detalhes" (click)="showDetails(info.id); currentProcedure(info.id)">
                                <td style="width: 2%;">
                                    <fa-icon [icon]="'chevron-down'" style="font-size: 10px"></fa-icon>
                                </td>
                                <td>{{info.name}}</td>
                                <td>{{info.plan.name}}</td>
                            </div>
                            <div [ngClass]="{'list-active': activeInfo === info.id, 'list-hidden': activeInfo !== info.id }" class="list-dropdown">
                                <div class="col-6 col-sm-6 d-flex flex-column" style="height: 100%; gap: 10px; padding-left: 6px;">
                                    <div class="details-text">
                                        <h3>Detalhes do processedimento</h3>
                                        <div>
                                            <span>Nome do plano atribuido: <strong>{{info.plan.name}}</strong> </span>
                                        </div>
                                        <br />
                                        <div>
                                            <div *ngIf="!editProcedurePrice">
                                                <span>Valor: <strong>{{info.price | currency}}</strong> </span> 
                                                <fa-icon 
                                                    icon="pencil-alt"
                                                    title="Alterar valor do procedimento" 
                                                    style="padding-left: 10px; cursor: pointer;"
                                                    (click)="editProcedurePrice = true; editPriceValue = info.price;"
                                                    *ngIf="!editProceduretransferAmmount && info.isActive"
                                                >
                                                </fa-icon>
                                            </div>
                                            <div *ngIf="editProcedurePrice" class="d-flex flex-wrap align-items-start gap-2">
                                                <input type="text" [(ngModel)]="editPriceValue" style="flex: 1 1 auto; min-width: 200px; max-width: 30%; margin-bottom: 2px;">
                                                <div class="d-flex flex-wrap gap-2">
                                                    <button
                                                        mat-button
                                                        class="btn-primary edit-save"
                                                        (click)="editPricesModal(info.id, info.name, info.price)"
                                                    >
                                                        Salvar
                                                    </button>
                                                    <button 
                                                        class="edit-cancel"
                                                        mat-button
                                                        (click)="editProcedurePrice = false; 
                                                        editPriceValue = null;"
                                                    >
                                                        Cancelar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <div>
                                            <div *ngIf="!editProceduretransferAmmount">
                                                <span>Valor repassado: <strong>{{info.transferAmmount | currency}}</strong> </span>
                                                <fa-icon 
                                                    icon="pencil-alt"
                                                    title="Alterar valor de repasse procedimento" 
                                                    style="padding-left: 10px; cursor: pointer;"
                                                    *ngIf="!editProcedurePrice && info.isActive"
                                                    (click)="editProceduretransferAmmount = true; editTransferAmmountValue = info.transferAmmount"
                                                >
                                                </fa-icon>
                                            </div>
                                            <div *ngIf="editProceduretransferAmmount" class="d-flex flex-wrap align-items-start gap-2">
                                                <input type="text" [(ngModel)]="editTransferAmmountValue" style="flex: 1 1 auto; min-width: 200px; max-width: 30%; margin-bottom: 2px;">
                                                <div class="d-flex flex-wrap gap-2">
                                                    <button
                                                        mat-button 
                                                        class="btn-primary edit-save"
                                                        color="primary"
                                                        (click)="editPricesModal(info.id, info.name, info.transferAmmount )"
                                                    >
                                                        Salvar
                                                    </button>
                                                    <button 
                                                        mat-button 
                                                        class="edit-cancel"
                                                        (click)="editProceduretransferAmmount = false;
                                                        editTransferAmmountValue = null;"
                                                    >
                                                        Cancelar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div style="margin-top: auto; margin-bottom: 5px;">
                                        <button 
                                            mat-button 
                                            class="btn-danger"
                                            (click)="modalInactivateProcedure(info.id, info.name)"
                                            *ngIf="info.isActive"
                                        >
                                            Inativar
                                        </button>
                                        <button
                                            mat-button
                                            class="btn btn-primary"
                                            *ngIf="!info.isActive"
                                            (click)="modalActiveProcedure(info.id, info.name)"
                                        >
                                            Ativar procedimento
                                        </button>
                                    </div>
                                </div>
                                
                                <div class="col-6 col-sm-6 d-flex flex-column" style="height: 100%;">
                                    <div style="width: 100%; gap: 5px; align-items: center;" class="d-flex flex-row" *ngIf="info.isActive">
                                       <div>
                                            <h3 style="margin-bottom: 0.6rem" >Adicionar especialidades:</h3>
                                       </div>
                                        <mat-form-field style="width: 30%;" class="col-6">
                                            <mat-label *ngIf="specialtyFilteredList.length > 0">Especialidades</mat-label>
                                            <mat-label *ngIf="specialtyFilteredList.length <= 0">Nenhuma especialidade disponível</mat-label>
                                            <mat-select [formControl]="specialtyForm" multiple [disabled]="specialtyFilteredList.length <= 0">
                                                <mat-option 
                                                *ngFor="let s of specialtyFilteredList; trackBy: trackById"
                                                [value]="s.id" [value]="s.id"
                                                >
                                                    {{s.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <button
                                            mat-raised-button 
                                            class="btn-primary responsive-button" 
                                            (click)="addSpecialtyModal(info.id, info.name, info.planId)"
                                            [disabled]="!specialtyForm?.value || specialtyForm.value.length <= 0"
                                        >
                                            Aplicar
                                        </button>
                                    </div>

                                    <div class="especialty-box">
                                        <div *ngIf="info.isActive && info.specialties.length > 0" class="box"> 
                                            <span *ngFor="let s of info.specialties" class="specialty-list">
                                                {{s.name}}
                                                <button 
                                                    title="Remover especialidade"
                                                    (click)="modalDeleteSpecialty(info.id, info.name, s.id, s.name)"
                                                    style="border: none; background-color: transparent; cursor: pointer;"
                                                >
                                                    <mat-icon color="warn">delete</mat-icon>
                                                </button>
                                            </span>
                                        </div>
                                        
                                        <span class="isInactive" *ngIf="!info.isActive">
                                            Este procedimento está inativo. Ative-o novamente para adicionar especialidades.
                                        </span>
                                        <span *ngIf="info.specialties.length <= 0 && info.isActive">
                                            Ainda não foi adicionado nenhuma especialidade nesse procedimento.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </tr>
                    </tbody>
                </table>
            </div>

            <mat-paginator 
                [length]="totalItems"
                [pageSize]="pageSize"
                [hidePageSize]="true"
                (page)="pageChange($event)"
            >
            </mat-paginator>
        </mat-card-content>
    </mat-card>
    
</app-ui-main-menu>